import producer from 'immer';
import assign from 'assign-deep';

import {
  startPhotoSession,
  saveChecklistItemInStorage,
  handleGetChecklistItems,
  handleGetChecklistItemsFromStorage,
  handleChecklistSessionFinish,
  handleUpdateIsChecklistValid,
  handleUpdateShouldOpenDialog,
  handleOpenFinishSessionDialog,
  updateChecklistSectionItem,
} from './handlers';

import {
  cloneFixedHouseAddressItems,
  mergeFixedHouseAddressItems,
} from './utils/houseAddressMerge';

import {
  START_PHOTO_SESSION,
  CHECKLIST_ITEM_CHANGED,
  UPDATE_STORAGE_CHECKLIST_ITEM,
  FETCH_API_CHECKLIST_ITEMS,
  UPDATE_HOUSE_ADDRESS,
  FETCH_CHECKLIST_FROM_STORAGE,
  FINISH_CHECKLIST_ACTION,
  FINISH_CHECKLIST_ERROR_UPDATE,
  CHECKLIST_CLEAN_STORE,
  CHECKLIST_VALID_CHANGED,
  CHECKLIST_OPEN_DIALOG_CHANGED,
  OPEN_FINISH_SESSION_DIALOG,
  UPDATE_CONDO_NAME,
} from './types';

export const initialState = {
  showError: false,
  hasFinishSessionError: false,
  finishSessionError: {},
  isDialogLoading: false,
  isSessionFinished: false,
  progress: 0,
  hasFetchedChecklistItems: false,
  hasFetchedChecklistItemsFromStorage: false,
  isFetchingChecklistFromStorage: false,
  fixed: {
    house: {
      items: {
        condoName: {
          value: '',
        },
        floor: {
          value: '',
        },
        complement: {
          value: '',
        },
        number: {
          value: '',
        },
        neighborhood: {
          value: '',
        },
        street: {
          value: '',
        },
      },
    },
    generalConditions: {},
    photoSession: {
      items: {},
    },
    contacts: {
      items: {
        type: {
          value: '',
        },
        name: {
          value: '',
        },
        phoneNumber: {
          value: '',
        },
        areaCode: {
          value: '',
        },
      },
    },
  },
  house: {},
  externalArea: {},
  isChecklistValid: true,
  shouldOpenDialog: false,
};

const updateHouseAddress = (_state, { houseItems }) => {
  const state = _state;

  if (state.fixed && state.fixed.house && state.fixed.house.items) {
    state.fixed.house.items = mergeFixedHouseAddressItems(
      cloneFixedHouseAddressItems(state.fixed.house.items),
      assign({}, state.fixed.house.items, houseItems),
    );
  }
  return state;
};

const updateCondoName = (_state, { condoName }) => ({
  ..._state,
  fixed: {
    ..._state.fixed,
    house: {
      ..._state.fixed.house,
      items: {
        ..._state.fixed.house.items,
        condoName: {
          value: condoName,
        },
      },
    },
  },
});

export const updateFinishChecklistError = (state, { properties }) => ({
  ...state,
  hasFinishSessionError: properties.hasFinishSessionError,
});

export const checklistReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_PHOTO_SESSION:
      return startPhotoSession(state, action);
    case CHECKLIST_ITEM_CHANGED:
      return updateChecklistSectionItem(state, action.properties);
    case UPDATE_STORAGE_CHECKLIST_ITEM:
      return saveChecklistItemInStorage(state, action);
    case UPDATE_HOUSE_ADDRESS:
      return updateHouseAddress(state, { houseItems: action.extraProperties });
    case FETCH_API_CHECKLIST_ITEMS:
      return handleGetChecklistItems(state, action);
    case FETCH_CHECKLIST_FROM_STORAGE:
      return handleGetChecklistItemsFromStorage(state, action);
    case FINISH_CHECKLIST_ACTION:
      return handleChecklistSessionFinish(state, action);
    case FINISH_CHECKLIST_ERROR_UPDATE:
      return updateFinishChecklistError(state, action);
    case CHECKLIST_CLEAN_STORE:
      return initialState;
    case CHECKLIST_VALID_CHANGED:
      return handleUpdateIsChecklistValid(state, action);
    case CHECKLIST_OPEN_DIALOG_CHANGED:
      return handleUpdateShouldOpenDialog(state, action);
    case OPEN_FINISH_SESSION_DIALOG:
      return handleOpenFinishSessionDialog(state, action);
    case UPDATE_CONDO_NAME:
      return updateCondoName(state, { condoName: action.condoName });
    default:
      return state;
  }
};

export default producer(checklistReducer);
